import React from "react";

export default function StripeTransactionIcon({ transactionId }) {
    if (!transactionId) return null;

    const id = transactionId.trim();
    const isCharge = id.startsWith("ch_");
    const isPayout = id.startsWith("py_");

    if (!isCharge && !isPayout) return null;

    const stripeUrl = `https://dashboard.stripe.com/payments/${id}`;

    return (
        <a
            href={stripeUrl}
            target="_blank"
            rel="noopener noreferrer"
            title="View on Stripe Dashboard"
            style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: 15,
                height: 15,
                borderRadius: "50%",
                backgroundColor: "#635BFF",
                color: "white",
                marginLeft: 8,
                textDecoration: "none",
            }}
        >
            <i className="bx bxl-stripe" style={{ fontSize: 12 }}></i>
        </a>
    );
}